import { getOrder } from "@gaiaherbs/Services/OrderServiceExtension";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, FetchOrderWithLines } from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/Reorder";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(chain, FetchOrderWithLines, async props => {
    const order = await getOrder({ orderNumber: props.parameter.orderNumber, expand: ["orderLines"] });
    props.apiResult = { order };
});
